import { QuestionSections } from "../components/questionnaire.component";
import { GraphQLResponse } from "./grapql.models";

export type QualitativeGraphObservable = {
  macroSections: GraphQLResponse<MacroSection>;
};
export type QualitativeFiltersGraphObservable = {
  qualitativeByQuery: GraphQLResponse<MacroSection>;
};

export interface Qualitative {
  macroSections: MacroSection;
}

export interface MacroSection {
  sectionTitle: string;
  questions: (Question & { id: number })[];
  sectionId: number;
  sectionDescription: string;
  sectionNumber?: number
}

export interface Question {
  content: string;
  questionOrder: number;
  ansGrp: AnswerGroup;
  id: string;
}

export interface AnswerGroup {
  group: string;
  id: string;
}

export interface SaveEvent {
  sectionId: string;
  titleSection: string;
  sectionDescription: string;
  sectionIndex: number;
  questionIndex: number;
  title: string;
  order: number;
  type: "multiple" | "text" | "yesOrNo";
  [id: string]: any;
}

export interface SaveSection extends QuestionSections {
  sectionIndex: number;
}

export enum MAP_QUESTION_GROUP {
  multiple = "MULTIPLE",
  yesOrNo = "YES_OR_NO",
  text = "TEXT",
  partial = "PARTIAL"
}

// export type SaveEvent = SV & Question;

// export type QualitativeInput = Omit<Qualitative, "id">;
